import { store } from "../store";
import { call, put, takeLatest } from "redux-saga/effects";

import ENV from "../config/env";
import {
  GET_ACTIVE_ADDRESSES_DROPDOWN_REQUEST,
  GET_BENFITS_DROPDOWN_REQUEST,
  GET_EQUIPMENT_PROFICIENCY_DROPDOWN_REQUEST,
  GET_FOCUS_AREA_DROPDOWN_REQUEST,
  GET_JOB_CITY_DROPDOWN_REQUEST,
  GET_JOB_DETAILS_REQUEST,
  GET_PAY_COMMISSION_DROPDOWN_REQUEST,
  GET_ROLETIRS_DROPDOWN_REQUEST,
  GET_SKILS_DROPDOWN_REQUEST,
  GET_SOFT_SKILLS_DROPDOWN_REQUEST,
  GET_SPECIALZATION_DROPDOWN_REQUEST,
  SAVE_APPLY_JOBS_REQUEST,
  SAVE_BASIC_JOB_DETAILS_REQUEST,
  SAVE_UPDATE_JOB_STATUS_REQUEST,
  VIEW_JOB_DETAILS_STATUS_REQUEST,
  GET_HOSPITAL_BASIC_INFO_REQUEST,
  GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST,
  GET_HOSPITAL_OWNERSHIP_INFO_REQUEST,
  GET_HOSPITAL_OTHER_DETAILS_REQUEST,
  GET_HOSPITAL_HOSTEL_DETAILS_REQUEST,
  GET_HOSPITAL_SOCIAL_INFO_REQUEST,
  GET_HOSPITAL_DOCUMENT_INFO_REQUEST,
} from "./hospitalManagement.type";
import { saveJobDetailsSuccess } from "./hospitalManagement.action";
import axiosInstance from "../../api/axiosInstance";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}
function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function* getOwnershipTypeDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/SkillsDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getSpecializationDropdownSaga(action) {
  const { callback } = action;
  const profession =
    action.payload?.profession ||
    store.getState()?.auth?.user?.candidateProfession;
  const professionQuery = profession
    ? `?profession=${encodeURIComponent(profession)}`
    : "";

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/SpecializationDropdown${professionQuery}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getDistinctJobCitiesDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}/gateway-service/company-service/findAll/DistinctJobCities`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getBasicInfoJobDetailsSaga(action) {
  const {
    payload: { user, companyTypeId },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/JobDetails?id=${user}&companyTypeId=${companyTypeId}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveBasicJobDetailsoSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/save/JobDetails`,
      payload,
      getAuthHeaders(),
    );
    yield put(saveJobDetailsSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getSoftSkillsDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/SoftSkillsEmphasisDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getFocusAreaDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/FocusAreaDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getPayCommissionDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/PayCommissionDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getRoleTierDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/RoleTierDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getCorporateBenefitsDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/CorporateBenefitsDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getEquipmentDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/RequiredEquipmentProficiencyDropdown`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getAddressDetailsIdsDropdownSaga(action) {
  const { callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/ActiveApprovedCompanyAddressDetailsIdsByState`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}


function* saveJobStatusDetailsSaga(action) {
  const {
    payload: { user, status },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/update/JobStatus?id=${user}&jobStatus=${status}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* applyJobSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateJobMapping`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* viewJobDetailsSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/JobDetails/ForInfoPage?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalBasicInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyBasicInfo?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalDemographicInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyDemographicInfo?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalOwnershipInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyOwnershipAndLegalInfo?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalOtherDetailsSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyOtherDetails?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalHostelDetailsSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyHostelDetails?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalSocialInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanySocialInfo?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalDocumentInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyDocInfo?id=${id}`,
      {},
      getAuthHeaders(),
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* hospitalManagementWatcherSaga() {
  yield takeLatest(VIEW_JOB_DETAILS_STATUS_REQUEST, viewJobDetailsSaga);
  yield takeLatest(SAVE_APPLY_JOBS_REQUEST, applyJobSaga);
  yield takeLatest(GET_ACTIVE_ADDRESSES_DROPDOWN_REQUEST, getAddressDetailsIdsDropdownSaga);

  
  yield takeLatest(GET_SKILS_DROPDOWN_REQUEST, getOwnershipTypeDropdownSaga);
  yield takeLatest(
    GET_SPECIALZATION_DROPDOWN_REQUEST,
    getSpecializationDropdownSaga,
  );
  yield takeLatest(
    GET_JOB_CITY_DROPDOWN_REQUEST,
    getDistinctJobCitiesDropdownSaga,
  );
  yield takeLatest(SAVE_BASIC_JOB_DETAILS_REQUEST, saveBasicJobDetailsoSaga);
  yield takeLatest(GET_JOB_DETAILS_REQUEST, getBasicInfoJobDetailsSaga);
  yield takeLatest(GET_SOFT_SKILLS_DROPDOWN_REQUEST, getSoftSkillsDropdownSaga);
  yield takeLatest(GET_FOCUS_AREA_DROPDOWN_REQUEST, getFocusAreaDropdownSaga);
  yield takeLatest(
    GET_PAY_COMMISSION_DROPDOWN_REQUEST,
    getPayCommissionDropdownSaga,
  );
  yield takeLatest(GET_ROLETIRS_DROPDOWN_REQUEST, getRoleTierDropdownSaga);
  yield takeLatest(
    GET_BENFITS_DROPDOWN_REQUEST,
    getCorporateBenefitsDropdownSaga,
  );
  yield takeLatest(
    GET_EQUIPMENT_PROFICIENCY_DROPDOWN_REQUEST,
    getEquipmentDropdownSaga,
  );
  yield takeLatest(SAVE_UPDATE_JOB_STATUS_REQUEST, saveJobStatusDetailsSaga);
  yield takeLatest(GET_HOSPITAL_BASIC_INFO_REQUEST, getHospitalBasicInfoSaga);
  yield takeLatest(GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST, getHospitalDemographicInfoSaga);
  yield takeLatest(GET_HOSPITAL_OWNERSHIP_INFO_REQUEST, getHospitalOwnershipInfoSaga);
  yield takeLatest(GET_HOSPITAL_OTHER_DETAILS_REQUEST, getHospitalOtherDetailsSaga);
  yield takeLatest(GET_HOSPITAL_HOSTEL_DETAILS_REQUEST, getHospitalHostelDetailsSaga);
  yield takeLatest(GET_HOSPITAL_SOCIAL_INFO_REQUEST, getHospitalSocialInfoSaga);
  yield takeLatest(GET_HOSPITAL_DOCUMENT_INFO_REQUEST, getHospitalDocumentInfoSaga);
}
